// ====================
// components/EducationSection.js
// ====================

import React from 'react';
import { ChevronRight } from 'lucide-react';

const EducationSection = () => {
  const courses = [
    "Data Structures & Algorithms", "Database Management", "Global IT & Ethics",
    "Software Design Patterns", "Software Refactoring", "Computer Architecture", "Advanced Programming",
    "Web Development", "Network Programming", "Scripting and Automation", "System Administration", "Web and App Security",
  ];

  return (
    <section id="education" className="education">
      <div className="container">
        <h2>Education</h2>
        
        <div className="education-card">
          <div className="education-header">
            <div>
              <h3>Bachelor of Science in Computer Science and Innovation</h3>
              <h4>Champlain College, Burlington, VT</h4>
              <p className="education-details">
                <span>Expected Graduation: May 2026</span>
                <span>GPA: 3.94</span>
                <span>Minor: Cybersecurity</span>
              </p>
            </div>
          </div>
          
          <div className="achievements">
            <h4>Academic Achievements</h4>
            <div className="achievement-list">
              <span className="achievement">Dean's List: 2022-2023, Fall 2024</span>
              <span className="achievement">President's List: Spring 2024</span>
            </div>
          </div>
          
          <div className="coursework">
            <h4>Relevant Coursework</h4>
            <div className="course-grid">
              {courses.map((course, index) => (
                <div key={index} className="course-item">
                  <ChevronRight size={16} />
                  {course}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EducationSection;